import React, { useContext, useEffect, useState } from "react";
import { IdentifierMappingContext } from "../IdentifierMappingContext";
import { BaseModal } from "../../common/Modal/BaseModal";
import { Close } from "@material-ui/icons";
import plantsIllustration from "../../../../assets/images/plants_illustration.png";
import MixpanelService from "../../utils/MixpanelService";
import { useIdentifierMappingSubmit } from "../Hooks/useIdentifierMappingSubmit";

export const RemoveIdentifierModal = () => {
  const {
    removeIdentifierModalOpen,
    coveredEntity340bId,
    setRemoveIdentifierModalOpen,
    activePharmacyGroup,
  } = useContext(IdentifierMappingContext);

  const identifierAssociation = removeIdentifierModalOpen?.identifier_association;
  const pharmacy = removeIdentifierModalOpen?.pharmacy;

  const { handleSubmit, submitting } = useIdentifierMappingSubmit({
    url: "/api/mapping_requests/remove",
    body: {
      id_340b: coveredEntity340bId,
      pharmacy_id: pharmacy?.id,
      pharmacy_public_id: pharmacy?.public_id,
      identifier: identifierAssociation?.identifier,
      identifier_type: identifierAssociation?.identifier_type,
      original_group_name: activePharmacyGroup,
    },
    successMessage: "Removal ID request submitted.",
    onSubmitSuccess: () => {
      MixpanelService.track("esp_horizon_removal_identifier_submitted");
      setRemoveIdentifierModalOpen(false);
    },
  });

  return (
    <BaseModal
      open={!!removeIdentifierModalOpen}
      onClose={() => setRemoveIdentifierModalOpen(false)}
      className="modal-center"
      width={470}
    >
      <div
        className="bg--light-navy py-4 px--32 flex align-items-center border--rounded-top justify-content-end"
        style={{ height: 80 }}
      >
        <img
          className="mt--32"
          style={{ width: 145, userSelect: "none", marginRight: 70 }}
          src={plantsIllustration}
          alt="plants_illustration"
        />
        <button
          className="button button--transparent border--none w--32 h--32"
          onClick={() => {
            MixpanelService.track("esp_horizon_removal_identifier_cancelled");
            setRemoveIdentifierModalOpen(undefined);
          }}
        >
          <Close sx={{ fontSize: 16 }} />
        </button>
      </div>
      <div className="p--32">
        <div className="t--500 t--xl">Remove Identifier</div>
        <div className="mt-2 mb-4 t--md">Are you sure you want to remove this identifier?</div>

        <div className="mb-4">
          <div className="px--12">
            <div className="t--sm t--secondary ml-1">Identifier *</div>
            <div className="my-3">
              {`${identifierAssociation?.identifier} / ${identifierAssociation?.identifier_type?.toUpperCase()}`}
            </div>
          </div>
        </div>

        <div className="flex align-items-center justify-content-end gap--8">
          <button
            className="button button--white"
            onClick={() => {
              MixpanelService.track("esp_horizon_removal_identifier_cancelled");
              setRemoveIdentifierModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="button button--blue"
            onClick={() => handleSubmit()}
            disabled={submitting}
          >
            Yes, Remove Identifier
          </button>
        </div>
      </div>
    </BaseModal>
  );
};
